import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { SelectButton, Loader } from "../StyledComponents";
import { ReactComponent as Check } from "../../svg/check.svg";

const INCOMPATIBLE_SLUGS = ['nest', 'fenix-manor', 'portrait-buttons', 'cozy-headboard'];
export const checkCompat = (slug) => !INCOMPATIBLE_SLUGS.includes(slug);

export const Headboards = ({ selected, handleClick }) => {
  const { loading, error, data } = useQuery(
    gql`
      query headboards($id: Int!) {
        bedType(id: $id) {
          id
          title
          headboards {
            id
            title
            onFloor
            slugEn
            productThumbnail(version: "byob-textile") {
              url
              width
              height
            }
          }
        }
      }
    `,
    { variables: { id: selected.bed.id } }
  );
  if (loading) return <Loader />;
  if (error) return <p>Error :(</p>;
  const items = data.bedType.headboards;

  return (
    <>
      {items.map((item, i) => (
        <SelectButton
          className={
            selected.headboards && parseInt(item.id) === selected.headboards.id
              ? "active"
              : "inActive"
          }
          key={i}
          onClick={() => {
            handleClick({
              id: parseInt(item.id),
              title: item.title,
              on_floor: item.onFloor,
              compat: checkCompat(item.slugEn),
            });
          }}
        >
          <img
            loading="lazy"
            src={item.productThumbnail.url}
            alt=""
            height="90"
            width="90"
          />
          <h3>{item.title}</h3>
          <Check />
        </SelectButton>
      ))}
    </>
  );
};
